var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMiniMusicSqaure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.572 20.26c-.04-.16-.06-.33-.06-.5 0-1.22.99-2.22 2.2-2.24-.37 1.22-1.1 2.16-2.14 2.74z",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.208 10.53-.128.03-2.95.82c-1.56.4-2.6 1.75-2.6 3.36v1.85a1 1 0 0 1-.4.8c-1.72 1.29-2.58 2.493-2.58 3.61H7.52C4.07 21 2 18.94 2 15.48V7.52C2 4.06 4.07 2 7.52 2h7.96C18.93 2 21 4.06 21 7.52v2.032a1 1 0 0 1-.792.978z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.921c-.16.01-.33.04-.52.09l-2.98.82c-.89.23-1.47.98-1.47 1.91v3.91c-.23-.08-.48-.13-.74-.13-1.24 0-2.25 1-2.25 2.24 0 .08 0 .16.01.24.12 1.12 1.08 2 2.24 2 1.22 0 2.21-.99 2.23-2.2 0-.02.01-.03.01-.04v-3.69l3.45-.95.52-.14v1.68c-.23-.08-.48-.14-.75-.14h-.04c-1.21.02-2.2 1.02-2.2 2.24 0 .17.02.34.06.5.23 1 1.12 1.75 2.18 1.75 1.23 0 2.22-.99 2.24-2.21 0-.01.01-.02.01-.04v-5.83c0-.76-.23-1.32-.69-1.68-.26-.19-.68-.39-1.31-.33zm-6.41 9.08a.494.494 0 0 1-.05-.24.745.745 0 0 1 1.49 0c0 .08-.01.15-.04.22-.09.3-.37.52-.7.52-.33 0-.61-.21-.7-.5zm5.42-1.24c0-.4.34-.74.74-.74.41 0 .75.34.75.74 0 .41-.34.75-.75.75-.4 0-.74-.34-.74-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMiniMusicSqaure);
export default __webpack_public_path__ + "static/media/vuesax-bold-mini-music-sqaure.362764d49d11cdf1b63b948e90e0351e.svg";
export { ForwardRef as ReactComponent };